/** @jsx jsx */
import PropTypes from 'prop-types'
import { Flex, jsx } from 'theme-ui'

const NavMenuLinks = ({ children, isOpen }) => {
  return (
    <Flex
      as="ul"
      sx={{
        backgroundColor: ['brandPrimary', null, 'transparent'],
        bottom: ['0', null, 'auto'],
        display: [isOpen ? 'block' : 'none', null, 'flex'],
        height: [null, null, '64px'],
        left: ['0', null, 'auto'],
        overflowY: ['scroll', null, 'visible'],
        p: [4, null, 0],
        position: ['fixed', null, 'static'],
        top: ['104px', null, 'auto'],
        width: ['100%', null, 'auto'],
        zIndex: ['100', null, '0'],
      }}
    >
      {children}
    </Flex>
  )
}

NavMenuLinks.propTypes = {
  isOpen: PropTypes.bool,
}

export default NavMenuLinks
